export default __webpack_public_path__ + "static/media/ARIcon.d2d14aba.svg";